import { render, staticRenderFns } from "./secoords-add.vue?vue&type=template&id=23e5f34d&scoped=true&"
import script from "./secoords-add.vue?vue&type=script&lang=js&"
export * from "./secoords-add.vue?vue&type=script&lang=js&"
import style0 from "./secoords-add.vue?vue&type=style&index=0&id=23e5f34d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e5f34d",
  null
  
)

export default component.exports